import { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import backIcon from '../assets/icon/backIcon.svg';
import { useNavigate } from 'react-router-dom';
import Accordion from '../components/Accordion/ComparePageAccordian';
import AccordionV from '../components/Accordion/Accordion';
import { Typography, Box } from '@mui/material';
import ModelView from '../components/PromptPlayGroundPopUp';
import PlainButton from '../components/ButtonComponent';
import { usePromptContext } from '../context/PromptContextType';
import { fetchMyPromptDetails } from '../service/apiServices';
import { useAzureData } from '../context/AzureContext';
import { ListGroup } from 'react-bootstrap';
import './PromptPlayground.css';
import {
  BlueDropDownComponent,
  RangeSelector,
  SearchableDropDownComponent,
  TextArea,
  TextFieldComponent,
  ToolTipFunction
} from '../components/inputField';
import { ReactComponent as DeletePopUpIcon } from '../assets/icon/DeletePopUpIcon.svg';
import data from '../data/promptPlayground.json';
import { Folder } from 'lucide-react';
import SideDrawer from '../components/SideDrawer';
import { UnileverButton } from '../components/ButtonComponents';
import { ReactComponent as BlackTrash } from '../assets/icon/blackTrash.svg';
import { usePromptPlaygroundContext } from '../context/PromptPlayGroundContext';
import CreditBalanceBox from '../components/CreditBalanceBox';
import { ReactComponent as Compare_Icon } from '../assets/icon/Compare_Icon.svg';
import { ReactComponent as Trash } from '../assets/icon/Trash.svg';
import { ReactComponent as Edit_Blue } from '../assets/icon/Edit_Blue.svg';
import { availableVariables } from '../utilities/helper';
import { ReactComponent as I_icon } from '../assets/icon/i_icon.svg';
import { isTemplateExpression } from 'typescript';
import SavePromptPopUp from '../components/SavePromptPopUp';
import ReactMarkdown from 'react-markdown';
import UnileverAnimation from '../components/UnileverAnimation';

export default function PromptPlaygroundCompare() {
  const navigate = useNavigate();
  const {
    promptsList,
    setPromptsList,
    //
    myPrompt,
    // creditData,
    creditDataFunction,
    // setSelectedApplication,
    setDeduction,
    selectedApplication,
    indexSelection,
    IndexOptions
  } = usePromptContext();
  const { apiToken } = useAzureData();
  const iconStyle = { width: 15, height: 15, marginRight: 5 };
  const {
    comparePromptHistoryFunction,
    comparePromptHistory,
    indexData,
    indexDetails,
    //
    compareRunFunction,
    compareRun,

    //
    runHistory,
    runHistoryFunction,

    //
    modelDataFunction,
    modelData,
    deleteCompareChat
  } = usePromptPlaygroundContext();

  const newCompare = {
    compare_prompt_id: '',
    executed_at: '',
    executed_by: '',
    input_message: [],
    owner_id: '',
    playground_name: 'New Comparison',
    run_id: ''
  };
  const { credit_id: CREDIT_ID = 0 } = selectedApplication || {};

  const promptId = myPrompt;
  useEffect(() => {
    creditDataFunction();
    if (promptId) {
      const temp = [...promptsList];
      if (temp?.indexOf(promptId) > -1) {
        setPromptsList(temp);
        return;
      }
      temp.push(promptId);
      setPromptsList(temp);
    }
    comparePromptHistoryFunction();
    indexDetails();
    modelDataFunction();
    return () => {
      setPromptsList([]);
      setDataToShow([]);
    };
  }, []);

  const [comparePromptHistory_, setComparePromptHistory] = useState([]);
  useEffect(() => {
    if (comparePromptHistory?.loading || comparePromptHistory?.error) {
      return;
    }
    if (comparePromptHistory?.data?.runs) {
      if (!!comparePromptHistory_?.[0]?.compare_prompt_id) {
        setComparePromptHistory([newCompare, ...comparePromptHistory?.data?.runs]);
      } else setComparePromptHistory([...comparePromptHistory?.data?.runs]);
    }
  }, [comparePromptHistory]);

  const [dataToShow, setDataToShow] = useState([]);
  const [userPrompt, setUserPrompt] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [popType, setPopUpType] = useState('');

  useEffect(() => {
    if (runHistory?.loading || runHistory?.error) {
      return;
    }

    const variants = runHistory?.data?.runs?.[0]?.variants;
    const temp = variants?.map((item) => ({
      configData: {
        model: item?.parameters?.model,
        temperature: item?.parameters?.temperature || 0,
        maximumLength: item?.parameters?.max_tokens,
        topP: item?.parameters?.top_P,
        frequencyPenalty: item?.parameters?.frequencyPenalty || 0,
        presencePenalty: item?.parameters?.frequencyPenalty || 0
      },
      promptsData: [
        {
          variables: item?.variables,
          version_id: '99',
          roles: runHistory?.data?.runs?.[0]?.input_message || [],
          prompt: {
            systemPrompt: item?.output_message?.systemPrompt,
            promptDescription: runHistory?.data?.description,
            promptName: runHistory?.data?.name,
            prompt_id: runHistory?.data?.prompt_id,
            llmTestedWith: item?.parameters?.model,
            //
            is_prompt_type_private: false,
            is_interaction_type_single: false
          }
        }
      ],
      prompt_id: runHistory?.data?.prompt_id,
      aiResponse: item?.output_message,
      meta: {
        currentVersion: 'dummy',
        totalVersions: 99,
        owner_id: 'dummy',
        is_owner: true
      }
    }));

    setUserPrompt(runHistory?.data?.runs?.[0]?.input_message);
    setDataToShow(temp);
  }, [runHistory]);

  useEffect(() => {
    if (promptsList?.length) {
      setIsLoading(true);
      try {
        fetchMyPromptDetails(promptsList[promptsList?.length - 1], apiToken)?.then((data) => {
          // fetching all versions
          const versionData = availableVariables(data?.promptsData);
          const version = versionData?.[0]?.version;

          const _temp = data?.promptsData?.filter(
            (item) => item?.prompt?.promptVersion == version
          )?.[0];

          // user prompt is to show the prompt in the right side box
          setUserPrompt(_temp?.roles?.length ? _temp?.roles : _temp?.prompt?.prompt);

          const temp = [
            ...dataToShow,
            {
              ...data,
              configData: { ...configDataDummy, model: _temp?.prompt?.llmTestedWith },
              aiResponse: [],
              allVersions: versionData,
              selectedVersion: version
            }
          ];
          setDataToShow(temp);
        });
      } catch (err) {
        console.log(err);
        alert(err);
      } finally {
        setIsLoading(false);
        setPopUpType('');
      }
    }
  }, [promptsList]);

  const handleComparePrompt = (type = '') => {
    if (type === 'newVersion') {
      setDataToShow([...dataToShow, dataToShow?.[dataToShow?.length - 1]]);
    } else setDataToShow([...dataToShow, newPrompt]);
  };

  const [historyData, setHistoryData] = useState<historyTypeData[]>([]);
  const [open, setOpen] = useState('');
  const [isViewMaximum, setIsViewMaximum] = useState(false);
  const [ModelOptions, setModeloptions] = useState([{ title: '', id: 0 }]);

  const handleNewCompare = () => {
    setDataToShow([]);
    if (comparePromptHistory_?.[0]?.compare_prompt_id) {
      setComparePromptHistory((prev) => [newCompare, ...prev]);
    }
  };

  useEffect(() => {
    setHistoryData(data?.items);
    // indexDetails(apiToken);
  }, []);

  const configDataFunction = (index: number) => {
    const configTemp = dataToShow[index]?.configData;
    return [
      { fieldName: 'Model', value: configTemp?.model },
      { fieldName: 'Temperature', value: configTemp?.temperature },
      { fieldName: 'Max Length', value: configTemp?.maximumLength },
      { fieldName: 'Stop Sequence', value: configTemp?.stopSequence?.join(' ') },
      { fieldName: 'Top P', value: configTemp?.topP },
      { fieldName: 'Frequency Penalty', value: configTemp?.frequencyPenalty },
      { fieldName: 'Presence Penalty', value: configTemp?.presencePenalty }
    ];
  };

  const configDataDummy = {
    model: ModelOptions?.[0]?.title,
    temperature: 1,
    maximumLength: 256,
    topP: 1,
    stopSequence: [],
    frequencyPenalty: 0,
    presencePenalty: 0
  };
  const [selectedTab, setSelectedTab] = useState(0);
  const resetNewPrompt = {
    promptsData: [
      {
        prompt: {
          promptName: 'New Prompt',
          systemPrompt: ''
        }
      }
    ],
    configData: configDataDummy,
    aiResponse: []
  };
  const [newPrompt, setNewPrompt] = useState(resetNewPrompt);
  const borderDetails = {
    border: '1px solid var(--border-color-grey)',
    borderRadius: 4
  };

  const [selectedPromptIndex, setSelectedPromptIndex] = useState(0);
  const savePromptValues = { isOwner: false, promptId: '', selectedVersion: 0, selectedIndex: 0 };
  const [savePromptPopUp, setSavePromptPopUp] = useState(savePromptValues);

  const resetAccordianStatus = {
    systemPrompt: false,
    config: false,
    userPrompt: false,
    aiResponse: false
  };
  const [accordianStatus, setAccordianStatus] = useState({
    ...resetAccordianStatus,
    systemPrompt: true,
    userPrompt: true
  });

  // Details of the selected promt in the Comparison box
  const promptDetails = (id: string, index: number) => {
    // const data = dataToShow?.filter((item) => item?.prompt_id == id)?.[0];
    const data = dataToShow?.[index];
    const versionFromDropDown = data?.selectedVersion;

    // const temp = data?.promptsData?.[parseInt(versionFromDropDown)];
    const temp = data?.promptsData?.filter(
      (fltr) => fltr?.prompt?.promptVersion == versionFromDropDown
    )?.[0];
    const userPromptDummyData = temp?.roles?.length ? temp?.roles : temp?.prompt?.prompt;
    const selectedVersionDetails = temp?.prompt;
    const versionData = temp?.variables;
    const ai_reponse = data?.aiResponse?.length;

    const handleRemoveComparision = (e: React.MouseEvent) => {
      e.stopPropagation();
      const updatedData = [...dataToShow.slice(0, index), ...dataToShow.slice(index + 1)];
      setDataToShow(updatedData);
    };

    const handleEdit = (e: React.MouseEvent, index) => {
      e.stopPropagation();
      setOpen('Edit');
      setSelectedPromptIndex(index);
    };

    const variableDisplay = (field, val) => {
      return (
        <div className="d-flex my-1">
          <Typography className="w-50" style={{ fontWeight: 600 }}>
            {field}
          </Typography>
          :
          <Typography className="mx-2" style={{ width: '75%', textWrap: 'wrap' }}>
            {val}
          </Typography>
        </div>
      );
    };

    const handleEditSystemPrompt = (val: any, index: any) => {
      // console.log(val, index, 'fdsfsdfdsfds');

      setDataToShow((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item;

          const selectedVersion = item.selectedVersion;

          return {
            ...item,
            promptsData: item.promptsData.map((pd) =>
              pd.prompt.promptVersion === selectedVersion
                ? {
                    ...pd,
                    prompt: {
                      ...pd.prompt,
                      systemPrompt: val
                    }
                  }
                : pd
            )
          };
        })
      );
    };

    // console.log(dataToShow, 'fdsdfss');
    /////

    const functionBox = (item: any) => {
      return item?.map((itm) => (
        <>
          <Box className="d-flex justify-content-end my-1">
            <Typography
              style={{
                borderRadius: '16px 0px 16px 16px',
                backgroundColor: '#005eef',
                // width: '90%',
                padding: '10px',
                textAlign: 'end',
                color: '#fff'
              }}
              id={itm?.user?.replace(/\s+/g, '_')}>
              {itm?.user}
            </Typography>{' '}
            <div className="circle-icon">👤</div>
          </Box>
          <Box className="d-flex justify-content-start my-1 ">
            <div className="circle-icon">🤖</div>{' '}
            <Typography
              style={{
                borderRadius: '0px 16px 16px 16px',
                backgroundColor: '#f1f1f1',
                // width: '90%',
                padding: '10px'
              }}>
              <span className="fw-bold">Assistant:</span>
              <br />
              {itm?.assistant}
            </Typography>
          </Box>
        </>
      ));
    };

    return (
      <div
        style={{ width: '50%', height: 'calc(100vh - 201px)' }}
        className="p-2 chat_history_container m-1">
        <div className="d-flex justify-content-between">
          <div className="d-flex justify-content-start align-items-center">
            <Typography className="un_standard_color">
              {selectedVersionDetails?.promptName || ''}
            </Typography>
            {!!data?.allVersions && (
              <BlueDropDownComponent
                versionsData={data?.allVersions}
                selectedVersion={parseInt(data?.selectedVersion)}
                handleSelection={(a: string, b: number) => {
                  const updated = [...dataToShow];
                  updated[index] = { ...updated[index], selectedVersion: b };
                  setDataToShow(updated);
                }}
              />
            )}
          </div>
          <UnileverButton
            buttonAction={() => {
              setSavePromptPopUp({
                isOwner: data?.meta?.is_owner,
                promptId: data?.prompt_id,
                selectedVersion: parseInt(data?.selectedVersion),
                selectedIndex: index
              });
            }}>
            Save Prompt
          </UnileverButton>
        </div>

        <Accordion
          title={'System Prompt'}
          isOpen={accordianStatus?.systemPrompt}
          handleStatus={() =>
            setAccordianStatus({ ...accordianStatus, systemPrompt: !accordianStatus?.systemPrompt })
          }
          rightButton={
            <div>
              <PlainButton styleClass={''} buttonAction={handleRemoveComparision}>
                <Trash style={{ marginRight: 5 }} />
                Remove Comparison
              </PlainButton>
            </div>
          }>
          <>
            <TextArea
              placeholder="Update System Prompt"
              value={selectedVersionDetails?.systemPrompt}
              areaStyle={{ height: 'auto', resize: 'vertical' }}
              action={(a) => {
                handleEditSystemPrompt(a, index);
              }}
            />
          </>
        </Accordion>
        <Accordion
          title={'Configuration'}
          isOpen={accordianStatus?.config}
          handleStatus={() =>
            setAccordianStatus({
              ...accordianStatus,
              config: !accordianStatus?.config
            })
          }
          rightButton={
            <PlainButton
              styleClass={''}
              buttonAction={(e) => {
                handleEdit(e, index);
                setAccordianStatus({ ...accordianStatus, config: true });
              }}>
              <Edit_Blue style={{ marginRight: 5 }} />
              Edit
            </PlainButton>
          }>
          <div className="d-flex w-100">
            {['Parameter', 'Variable']?.map((item, index) => (
              <p
                className="me-2"
                style={index === selectedTab ? activeButtonStyle : {}}
                onClick={() => {
                  setSelectedTab(index);
                }}>
                {item}
              </p>
            ))}
          </div>{' '}
          {selectedTab === 0 &&
            configDataFunction(index)?.map((item) => (
              <div className="d-flex my-1">
                <Typography className="w-50" style={{ fontWeight: 600 }}>
                  {item?.fieldName}
                </Typography>
                :<Typography className="mx-2">{item?.value}</Typography>
              </div>
            ))}
          {selectedTab === 1 &&
            versionData?.map((item) => (
              <div style={{ ...borderDetails }}>
                {variableDisplay('Variable Name', item?.VariableName)}
                {variableDisplay('Descrition', item?.Description)}
                {variableDisplay('Default Value', item?.DefaultValue)}
              </div>
            ))}
        </Accordion>
        {/*User Prompt */}
        <Accordion
          title={'User Prompts'}
          isOpen={accordianStatus?.userPrompt}
          handleStatus={() =>
            setAccordianStatus({
              ...accordianStatus,
              userPrompt: !accordianStatus?.userPrompt
            })
          }>
          <Typography>
            {userPromptDummyData?.map((item) =>
              item?.role ? (
                <>
                  <span className="un_standard_color w400">{item?.role}</span>:{item?.message}
                  <br />
                  <br />
                </>
              ) : (
                <>{item?.text}</>
              )
            )}
          </Typography>
        </Accordion>
        <div className="d-flex justify-content-center">
          {unileverIconShow && <UnileverAnimation />}
        </div>

        {!!ai_reponse && (
          <Accordion
            title={'AI Response'}
            isOpen={accordianStatus?.aiResponse}
            handleStatus={() =>
              setAccordianStatus({
                ...accordianStatus,
                aiResponse: !accordianStatus?.aiResponse
              })
            }>
            {functionBox(dataToShow?.[index]?.aiResponse)}
          </Accordion>
        )}
      </div>
    );
  };

  const AddPrompt = () => {
    return (
      <div
        style={{ width: '50%', height: 'calc(100vh - 201px' }}
        className="chat_history_container m-1 d-flex flex-column justify-content-center align-items-center ">
        <Typography className="w-75">
          Add a comparison to see how a different prompt, Model, and/or parameter settings change
          the model output.
        </Typography>

        <br />
        <PlainButton
          styleClass={''}
          buttonAction={() => {
            setPopUpType('promptLibrary');
          }}>
          + Compare from prompt Library
        </PlainButton>

        {dataToShow?.length > 0 && (
          <PlainButton
            styleClass={''}
            buttonAction={() => {
              dataToShow?.length === 0
                ? setPopUpType('promptLibrary')
                : handleComparePrompt('newVersion');
            }}>
            + Duplicate Prompt
          </PlainButton>
        )}
      </div>
    );
  };

  const unileverIconShow = compareRun?.loading;
  const isRunButtunActive = !unileverIconShow;

  // for updating config values of specifically selected prompt
  const handleSelection = (fieldName: string, value: string) => {
    const updatedData = [...dataToShow];
    const temp = fieldName === 'stopSequence' ? value?.split(' ') : value;

    updatedData[selectedPromptIndex] = {
      ...updatedData[selectedPromptIndex],
      configData: {
        ...updatedData[selectedPromptIndex].configData,
        [fieldName]: temp //
      }
    };
    setDataToShow(updatedData);
  };

  // setting Model and Index Value
  useEffect(() => {
    const values_2 = modelData?.data?.endpoints;
    if (Array.isArray(values_2)) {
      const temp = values_2?.map((item) => {
        // return { title: item?.endpoint_name, id: item?.endpoint_group_id };
        return { title: item?.endpoint_name, id: item?.endpoint_name };
      });
      setModeloptions(temp || []);
    }
  }, [modelData]);

  const activeButtonStyle = {
    textDecoration: 'underline',
    textUnderlineOffset: '6px',
    textDecorationThickness: '2px',
    fontWeight: '600px',
    marginRight: '10px',
    color: 'var(--uni_std_clr)'
  };

  const sideBarData = dataToShow[selectedPromptIndex]?.configData;

  // const sideBarVariableData =
  //   dataToShow[selectedPromptIndex]?.promptsData?.[version - 1]?.variables || [];

  const sideBarVariableData =
    dataToShow[selectedPromptIndex]?.promptsData?.filter(
      (item) => item?.prompt?.promptVersion == dataToShow[selectedPromptIndex]?.selectedVersion
    )?.[0]?.variables || [];

  const updateFunction = (newVariables = {}) => {
    const updatedData = [...dataToShow];

    const temp = updatedData[selectedPromptIndex];

    updatedData[selectedPromptIndex] = {
      ...temp,
      promptsData: updatedData[selectedPromptIndex].promptsData.map((promptItem, i) => {
        // console.log(temp?.selectedVersion == promptItem?.prompt?.promptVersion, 'gdfgfdgfgfgfgd');

        if (temp?.selectedVersion == promptItem?.prompt?.promptVersion) {
          return {
            ...promptItem,
            variables: newVariables
          };
        }
        return promptItem;
      })
    };

    setDataToShow(updatedData);
  };

  const handleVariableUpdates = (name, value, index) => {
    const tempVariables = [...sideBarVariableData];

    if (name === 'VariableName' && value?.includes(' ')) {
      alert('space(" ") not allowed , instead use "_" ');
      return;
    }

    tempVariables[index] = {
      ...tempVariables[index],
      [name]: value
    };
    updateFunction(tempVariables);
  };

  const variableFields = (item, index) => {
    const handleDeleteVariable = () => {
      // Step 1: remove variable locally
      const temp = [...sideBarVariableData];

      temp.splice(index, 1);
      // // Step 2: update main data structure
      updateFunction(temp);
    };

    return (
      <div
        style={{
          ...borderDetails,
          padding: 16,
          marginTop: 20,
          position: 'relative'
        }}
        key={index}>
        <BlackTrash
          style={{ position: 'absolute', top: 30, right: 20, cursor: 'pointer' }}
          onClick={handleDeleteVariable}
        />
        {[
          {
            header: 'Variable Name',
            placeholder: 'Enter Variable Name',
            paramName: 'VariableName'
          },
          {
            header: 'Default Value',
            placeholder: 'Enter Value',
            paramName: 'DefaultValue'
          },
          {
            header: 'Description',
            placeholder: 'Description',
            paramName: 'Description'
          }
        ].map((dt, indx) => (
          <TextFieldComponent
            toolTip={
              (indx === 0 &&
                'Create reusable fields that can be inserted into the prompt using {{variableName}}. Add a name, optional default value, and a short description for each variable.') ||
              ''
            }
            key={dt.paramName}
            header={dt.header}
            isMandatory={false}
            placeholder={dt.placeholder}
            paramName={dt.paramName}
            value={item?.[dt.paramName] || ''}
            handleSelection={(paramName, val) => handleVariableUpdates(paramName, val, index)}
          />
        ))}
      </div>
    );
  };

  const handleAddVariable = (e) => {
    e.stopPropagation();

    const dummy = {
      VariableName: '',
      DefaultValue: '',
      Description: ''
    };

    const temp = [...sideBarVariableData];

    if (!temp.length || temp[0].VariableName) {
      const newVariables = [dummy, ...temp];
      updateFunction(newVariables);
    } else {
      alert('Please fill the already added variables first');
    }
  };

  const handleNewPrompt = (name, value) => {
    if (name === 'systemPrompt') {
      const temp = [
        {
          prompt: {
            promptName: 'New Prompt',
            systemPrompt: value
          }
        }
      ];

      setNewPrompt({ ...newPrompt, promptsData: temp });
      return;
    }
    const temp = name === 'stopSequence' ? value?.split(' ') : value;
    setNewPrompt({
      ...newPrompt,
      configData: {
        ...newPrompt.configData,
        [name]: temp
      }
    });
  };

  // console.log(dataToShow , "fsdfdsfsd")

  const handleRun = () => {
    const selectedIndex = IndexOptions?.filter((item) => item?.id === indexSelection?.index)?.[0];
    let tempVarient_;
    const rag_index = {
      index: selectedIndex?.title,
      ai_search_service_name: selectedIndex?.serviceName,
      search_top_k: indexSelection?.topK,
      rag_only: false
    };
    const tempVarient = dataToShow?.map((item) => {
      const choosenVersion = item?.promptsData?.filter(
        (fltr) => fltr?.prompt?.promptVersion == item?.selectedVersion
      )?.[0];

      // tempVarient_ , used to differentiate the temoVariant data , when ragIndex is selected or not

      const dt = item?.configData;
      const dt_variable = choosenVersion?.variables;
      const dt_systemPrompt = choosenVersion?.prompt?.systemPrompt;

      const dt_input_message = !!choosenVersion?.prompt?.prompt?.length
        ? choosenVersion?.prompt?.prompt
        : choosenVersion?.roles;

      return {
        systemPrompt: dt_systemPrompt,
        input_message: [...dt_input_message, ...item?.aiResponse],
        parameters: {
          model: dt?.model,
          temperature: dt?.temperature,
          max_length: dt?.maximumLength,
          top_p: dt?.topP,
          frequencyPenalty: dt?.frequencyPenalty,
          presencePenalty: dt?.presencePenalty,
          stopSequence: dt?.stopSequence
        },
        variables: dt_variable
      };
    });

    if (rag_index?.index) {
      tempVarient_ = tempVarient?.map((item) => ({ ...item, rag: rag_index }));
    } else tempVarient_ = tempVarient;

    const temp_ = dataToShow?.[0]?.promptsData?.filter(
      (fltr) => fltr?.prompt?.promptVersion == dataToShow?.[0]?.selectedVersion
    )?.[0];
    // const temp_1 = temp_?.roles?.length ? temp_?.roles : temp_?.prompt?.prompt;
    const temp_1 = userPromptData || '';

    const payLoad = {
      playground: {
        name: temp_?.prompt?.promptName || '',
        description: temp_?.promptDescription || '',
        prompt_id: promptsList?.[0] || temp_?.prompt?.prompt_id
      },
      run: {
        credit_id: CREDIT_ID?.toString(),
        user_prompt: [{ text: temp_1 }],
        variants: tempVarient_
      }
    };

    compareRunFunction(payLoad);
    setAccordianStatus(resetAccordianStatus);
  };

  useEffect(() => {
    if (compareRun?.loading) {
      return;
    }
    const error_ = compareRun?.error;

    if (error_) {
      alert(error_);
      console.log(error_);
      return;
    }

    const tempData = compareRun?.data;
    const availableVariants = tempData?.variants;

    const tempDataToShow = [...dataToShow];

    availableVariants?.forEach((item, index) => {
      const _temp = tempDataToShow[index];
      const responseCompre = item?.output_message;
      const tempAiReponse = [
        ..._temp?.aiResponse,
        { user: userPromptData, assistant: responseCompre?.message }
      ];
      if (tempDataToShow[index]) {
        tempDataToShow[index] = {
          ...tempDataToShow[index],
          aiResponse: tempAiReponse
        };
      }
    });
    setDeduction(tempData?.total_actual_cost);
    setDataToShow(tempDataToShow);
    setAccordianStatus({
      systemPrompt: false,
      config: false,
      userPrompt: false,
      aiResponse: true
    });

    // creditDataFunction();
    setUserPromptData('');
  }, [compareRun]);

  const [userPromptData, setUserPromptData] = useState('');

  const savePromptData = dataToShow[savePromptPopUp?.selectedIndex];

  const savePromptMessages = savePromptData?.promptsData?.filter(
    (item) => item?.prompt?.promptVersion == savePromptPopUp?.selectedVersion
  )?.[0];
  const savePromptMessages_InteractionBased = savePromptMessages?.roles?.length
    ? savePromptMessages?.roles
    : savePromptMessages?.prompt?.prompt;

  // console.log(savePromptData, 'vvvvvsavePromptMessages', dataToShow);

  return (
    <div className="p-2">
      <ModelView
        header={isLoading ? 'Loading.....' : 'Prompt Samples'}
        open={!!popType}
        handleClose={() => {
          !isLoading && setPopUpType('');
        }}></ModelView>

      {open === 'History' && (
        <SideDrawer isOpen={!!open} handleClose={() => setOpen('')}>
          <div className="chat_history_container">
            <div className="playground-container">
              <div className="header mt-2 ps-2">
                <h5 className="m-0">Comparison History</h5>
              </div>
              <UnileverButton buttonAction={handleNewCompare} styleClass={{ width: '100%' }}>
                {' '}
                + New Comparison
              </UnileverButton>

              <Typography className="mb-1 mt-3 h7_400" style={{ color: 'var(--description_grey)' }}>
                Comparisons
              </Typography>
              <ListGroup variant="flush" className="history-list h-100">
                {comparePromptHistory?.loading ? (
                  <p>Loading Compare History...</p>
                ) : (
                  comparePromptHistory_?.map((item, index) => (
                    <ToolTipFunction toolTipText={<>{item?.playground_name}</>} placement="bottom">
                      <ListGroup.Item
                        key={item?.compare_prompt_id}
                        action
                        // className={index === 0 ? 'active-item' : ''}
                        className={index === 0 ? 'active-item listItemHover' : '' + 'listItemHover'}
                        // title={item?.name}
                        onClick={() => {
                          item?.compare_prompt_id
                            ? runHistoryFunction(item?.compare_prompt_id)
                            : handleNewCompare();
                          setOpen('');
                        }}
                        style={{ maxWidth: '95%', padding: 10 }}>
                        {/* {item?.playground_name} */}
                        <div className="d-flex position-relative">
                          <span> {item?.playground_name}</span>{' '}
                          {item?.compare_prompt_id && (
                            <DeletePopUpIcon
                              style={{ width: '25px', height: '25px' }}
                              className="position-absolute trashIcon"
                              onClick={(e) => {
                                e.stopPropagation();
                                deleteCompareChat(item?.compare_prompt_id);
                                const temp = comparePromptHistory_?.filter(
                                  (hstry) => hstry?.compare_prompt_id !== item?.compare_prompt_id
                                );
                                setComparePromptHistory(temp);
                              }}
                            />
                          )}
                        </div>
                      </ListGroup.Item>
                    </ToolTipFunction>
                  ))
                )}
              </ListGroup>
            </div>
          </div>
        </SideDrawer>
      )}

      {open === 'Edit' && (
        <SideDrawer isOpen={!!open} handleClose={() => setOpen('')}>
          <div className="w-100 p-2">
            <PageHeader
              headerName="Configure"
              description="Configure parameters to refine the model's output"
            />
            <div className="d-flex cursor-pointer">
              {['Parameter', 'Variable']?.map((item, index) => (
                <p
                  className="me-2"
                  style={index === selectedTab ? activeButtonStyle : {}}
                  onClick={() => {
                    setSelectedTab(index);
                  }}>
                  {item}
                </p>
              ))}
            </div>
            {selectedTab === 0 && (
              <div style={{ width: '95%', margin: 'auto' }}>
                <SearchableDropDownComponent
                  fieldName="Model"
                  isMandatory={false}
                  options={ModelOptions}
                  paramName={'model'}
                  value={sideBarData?.model}
                  handleSelection={(a, b) => handleSelection(a, b)}
                />

                <div className="my-3">
                  {[
                    {
                      fieldName: 'Temperature',
                      paranName: 'temperature',
                      min: 0,
                      max: 2,
                      steps: 2 / 10,
                      toolTipMessage:
                        'Controls randomness. Higher temperature generates more creative responses; lower temperature makes output more focused and deterministic.',
                      value: sideBarData?.temperature
                    },
                    {
                      fieldName: 'Maximum Length',
                      paranName: 'maximumLength',
                      min: 1,
                      max: 4000,
                      steps: 4000 / 100,
                      value: sideBarData?.maximumLength,
                      toolTipMessage:
                        'Defines the maximum number of tokens the model can generate in the response.'
                    }
                  ]?.map((item) => (
                    <div>
                      <RangeSelector
                        toolTip={item.toolTipMessage}
                        name={item?.fieldName}
                        paramName={item?.paranName}
                        handleSelection={(a, b) => handleSelection(a, b)}
                        min={item?.min}
                        max={item?.max}
                        steps={item?.steps}
                        value={item?.value}
                      />
                    </div>
                  ))}
                </div>
                <div className="my-3 relative">
                  <TextArea
                    toolTip="Specify one or more sequences where the model will stop generating further
                          output."
                    header="Stop Sequence"
                    description="Enter sequence and press tab"
                    numberOfLines={1}
                    areaStyle={{ height: '50px', padding: 12 }}
                    value={sideBarData?.stopSequence?.join(' ')}
                    action={(val) => handleSelection('stopSequence', val)}
                    onKeyDown={(e) => {
                      if (e.key === 'Tab') {
                        e.preventDefault();
                        handleSelection('stopSequence', e.target.value + ' ');
                      }
                    }}
                  />
                </div>

                <div className="my-3">
                  {[
                    {
                      fieldName: 'Top P',
                      paranName: 'topP',
                      min: 0,
                      max: 1,
                      step: 1 / 10,
                      value: sideBarData?.topP,
                      toolTipMessage:
                        'Controls diversity using nucleus sampling. The model considers only the most probable tokens whose cumulative probability reaches the Top-P value.'
                    },
                    {
                      fieldName: 'Frequency Penalty',
                      paranName: 'frequencyPenalty',
                      min: -2,
                      max: 2,
                      step: 2 / 10,
                      value: sideBarData?.frequencyPenalty,
                      toolTipMessage:
                        'Reduces the likelihood of the model repeating the same words. Higher values discourage repetition.'
                    },
                    {
                      fieldName: 'Presence Penalty',
                      paranName: 'presencePenalty',
                      min: -2,
                      max: 2,
                      step: 2 / 10,
                      value: sideBarData?.presencePenalty,
                      toolTipMessage:
                        'Encourages the model to talk about new topics. Higher values increase the chance of introducing fresh ideas.'
                    }
                  ]?.map((item) => (
                    <div>
                      <RangeSelector
                        toolTip={item.toolTipMessage}
                        name={item?.fieldName}
                        paramName={item?.paranName}
                        handleSelection={(a, b) => handleSelection(a, b)}
                        min={item?.min}
                        max={item?.max}
                        steps={item?.steps}
                        value={item?.value}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {selectedTab === 1 && (
              <div
                style={{
                  ...borderDetails,
                  padding: 16,
                  marginTop: 20,
                  position: 'relative'
                }}>
                <AccordionV
                  title="Variables"
                  defaultValue={false}
                  rightButton={
                    <PlainButton buttonAction={handleAddVariable}>+ Add Variables</PlainButton>
                  }>
                  <div className="mt-2">
                    {sideBarVariableData?.map((item, index) => variableFields(item, index))}
                  </div>
                </AccordionV>
              </div>
            )}
          </div>
        </SideDrawer>
      )}

      {open === 'New' && (
        <SideDrawer
          isOpen={!!open}
          handleClose={() => {
            setOpen('');
            setNewPrompt(resetNewPrompt);
          }}>
          <div className="w-100 p-2">
            <PageHeader headerName="New Prompt" description="Add New Prompt to compare" />
            <div className="d-flex cursor-pointer"></div>

            <TextArea
              header="System Prompt 1"
              numberOfLines={3}
              areaStyle={{ height: '250px', padding: 12 }}
              action={(val) => handleNewPrompt('systemPrompt', val)}
              value={newPrompt?.promptsData?.[0]?.prompt?.systemPrompt}
            />

            <div style={{ width: '95%', margin: 'auto' }}>
              <SearchableDropDownComponent
                fieldName="Model"
                isMandatory={false}
                options={ModelOptions}
                paramName={'model'}
                value={newPrompt?.configData?.model}
                handleSelection={(a, b) => handleNewPrompt(a, b)}
              />

              <div className="my-3">
                {[
                  {
                    fieldName: 'Temperature',
                    paranName: 'temperature',
                    min: 0,
                    max: 2,
                    steps: 2 / 10,
                    value: newPrompt?.configData?.temperature,
                    toolTipMessage:
                      'Controls randomness. Higher temperature generates more creative responses; lower temperature makes output more focused and deterministic.'
                  },
                  {
                    fieldName: 'Maximum Length',
                    paranName: 'maximumLength',
                    min: 1,
                    max: 4000,
                    steps: 4000 / 100,
                    value: newPrompt?.configData?.maximumLength,
                    toolTipMessage:
                      'Defines the maximum number of tokens the model can generate in the response.'
                  }
                ]?.map((item) => (
                  <div>
                    <RangeSelector
                      name={item?.fieldName}
                      paramName={item?.paranName}
                      handleSelection={(a, b) => handleNewPrompt(a, b)}
                      min={item?.min}
                      max={item?.max}
                      steps={item?.steps}
                      value={item?.value}
                    />
                  </div>
                ))}
              </div>
              <div className="my-3 relative">
                <div style={{ position: 'absolute', right: '30%' }}>
                  <ToolTipFunction
                    toolTipText={
                      <>
                        Specify one or more sequences where the model will stop generating further
                        output.
                      </>
                    }>
                    <I_icon />
                  </ToolTipFunction>
                </div>
                <TextArea
                  header="Stop Sequence"
                  description="Enter sequence and press tab"
                  numberOfLines={1}
                  value={newPrompt?.configData?.stopSequence?.join(' ')}
                  areaStyle={{ height: '50px', padding: 12 }}
                  action={(val) => handleNewPrompt('stopSequence', val)}
                  onKeyDown={(e) => {
                    if (e.key === 'Tab') {
                      e.preventDefault();
                      handleNewPrompt('stopSequence', e.target.value + ' ');
                    }
                  }}
                />
              </div>

              <div className="my-3">
                {[
                  {
                    fieldName: 'Top P',
                    paranName: 'topP',
                    min: 0,
                    max: 1,
                    step: 1 / 10,
                    value: newPrompt?.configData?.topP,
                    toolTipMessage:
                      'Controls diversity using nucleus sampling. The model considers only the most probable tokens whose cumulative probability reaches the Top-P value.'
                  },
                  {
                    fieldName: 'Frequency Penalty',
                    paranName: 'frequencyPenalty',
                    min: -2,
                    max: 2,
                    step: 2 / 10,
                    value: newPrompt?.configData?.frequencyPenalty,
                    toolTipMessage:
                      'Reduces the likelihood of the model repeating the same words. Higher values discourage repetition.'
                  },
                  {
                    fieldName: 'Presence Penalty',
                    paranName: 'presencePenalty',
                    min: -2,
                    max: 2,
                    step: 2 / 10,
                    value: newPrompt?.configData?.presencePenalty,
                    toolTipMessage:
                      'Encourages the model to talk about new topics. Higher values increase the chance of introducing fresh ideas.'
                  }
                ]?.map((item) => (
                  <div>
                    <RangeSelector
                      toolTip={item.toolTipMessage}
                      name={item?.fieldName}
                      paramName={item?.paranName}
                      handleSelection={(a, b) => handleNewPrompt(a, b)}
                      min={item?.min}
                      max={item?.max}
                      steps={item?.steps}
                      value={item?.value}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div>
              <PlainButton
                buttonAction={() => {
                  setOpen('');
                  setNewPrompt(resetNewPrompt);
                }}>
                Cancel
              </PlainButton>
              <UnileverButton
                buttonAction={() => {
                  handleComparePrompt('apply');
                  setOpen('');
                }}>
                Apply
              </UnileverButton>
            </div>
          </div>
        </SideDrawer>
      )}

      <div>
        <button
          onClick={() => navigate(`/promptplayground`)}
          className="btn btn-link text-muted p-0 mb-3 text-decoration-none back_btn">
          <img src={backIcon} alt="back" height="14px" style={{ marginRight: 5 }} />
          Back
        </button>
        <div className="d-flex align-items-center  justify-content-between">
          <PageHeader
            headerName="Compare"
            description="Refine your prompts compare outputs, and unlock new ways to interact with AI">
            <Compare_Icon />
          </PageHeader>{' '}
          <div>
            <PlainButton buttonAction={() => setOpen('History')}>
              <Folder style={iconStyle} />
              History
            </PlainButton>
            <PlainButton buttonAction={() => setIsViewMaximum(!isViewMaximum)}>
              <Folder style={iconStyle} />
              {isViewMaximum ? 'Minimize' : 'Maximize'} UI
            </PlainButton>
          </div>
        </div>
      </div>
      <div className="d-flex w-100 justify-content-between">
        <SavePromptPopUp
          open={!!savePromptPopUp?.promptId}
          handleClose={() => {
            setSavePromptPopUp(savePromptValues);
          }}
          isNew={'New'}
          header="Save Prompt"
          description={myPrompt ? 'Save Your New Prompt' : 'Select where to save the prompt'}
          // inputData={inputData}
          allMessages={savePromptMessages_InteractionBased || []}
          dataToShow={savePromptData}
          selectedVersion={savePromptPopUp?.selectedVersion}
        />
        {dataToShow?.map((item, index) => promptDetails(item?.prompt_id, index))}

        {/* PromptDetails */}
        {dataToShow?.length < 3 && AddPrompt()}
        {/* Right Box */}
        <div className={isViewMaximum ? 'd-none' : 'd-inline'} style={{ width: '20%' }}>
          <div className="chat_history_container">
            <CreditBalanceBox />
            <div className="p-2">
              <div className="d-flex justify-content-between w-100 align-items-center">
                <Typography className="w400">
                  {/* User Prompt<span style={{ color: 'red' }}>*</span> */}
                  <b>
                    User Question<span style={{ color: 'red' }}>*</span>
                  </b>
                </Typography>
                {userPromptData ? (
                  isRunButtunActive ? (
                    dataToShow?.length > 0 && (
                      <UnileverButton buttonAction={handleRun}>Run Prompt</UnileverButton>
                    )
                  ) : (
                    <PlainButton>Running..</PlainButton>
                  )
                ) : (
                  <></>
                )}
              </div>

              <div className="w-100">
                <TextArea
                  disabled={unileverIconShow}
                  placeholder="Ask your Follow Up Question."
                  numberOfLines={1}
                  areaStyle={{ height: '150px', padding: 12 }}
                  action={(val) => setUserPromptData(val)}
                  value={userPromptData}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault(); // stops new line
                      if (userPromptData.trim() && isRunButtunActive && dataToShow?.length > 0) {
                        handleRun();
                      }
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
